import { normalizePath, useSetFlowTo } from 'Simple/Flow'

export function useOnClick(props) {
  let setFlowTo = useSetFlowTo(props.viewPath)

  return function onClick() {
    window.open('https://support.greyfinch.com', '_blank')
    setFlowTo(normalizePath(props.viewPath, '../../No'))
  }
}
